import CustomFieldProto from '../../proto/custom-field-proto';
import ListComponent from './components/list-list';
import ListGroupHeaderComponent from "./components/list-group-list-header";
import TListGroupHeader1Component from "./components/list-group-t-list-header-1";
import TListGroupHeader2Component from "./components/list-group-t-list-header-2";
import ViewComponent from './components/list-view';
import EditComponent from './components/edit';
import FormComponent from "./components/form";
import FormNewComponent from './components/list-form-new';
import FieldDropdownViewInImport from "./components/view-in-preview";

export default class ListCustomField extends CustomFieldProto {

    constructor(customField) {
        super(customField);
    }

    get defaultWidth() {return 250} // default column width

    getValueById(id) {
        const option = _.find(this.customField.params.listItems, (option) => {
            return option.id === id;
        });

        return option?option.value:null;
    }

    getCsvValue(item) {
        const { customFieldsData } = item;
        let res = '';
        if (!!customFieldsData[this.customField.id]) {
            const option = _.find(this.customField.params.listItems, li => li.id === customFieldsData[this.customField.id]);
            if (option) res = option.value;
        }
        return res;
    }

    listItemGroupFunction() {
        return i=>i.item.customFieldsData[this.customField.id] ? i.item.customFieldsData[this.customField.id] : null;
    }

    listItemSortFunctions(sort) {
        return {
            functions: [
                i => !!sort ? 0 : !!i.item.customFieldsData[this.customField.id] ? 1 : 2,
                i => {
                    if (!(this.customField.id in i.item.customFieldsData)) return 0;
                    if (!this.customField.params || !this.customField.params.listItems || this.customField.params.listItems.length < 2) return 0;

                    const value = i.item.customFieldsData ? i.item.customFieldsData[this.customField.id] : -1;

                    let optionIdxPlus1 = 1;
                    this.customField.params.listItems.some(li => {
                        if (li.id === value) {
                            return true;
                        }
                        optionIdxPlus1++;
                    });

                    return optionIdxPlus1;
                }
            ],
            directions: ['asc', sort]
        }
    }

    groupValue(value) {
        let res = null;
        const option = _.find(this.customField.params.listItems, li => li.id == value); // '==' is intentional to make no difference for number and string
        if (option) res = option.value;
        return res;
    }

    sortValue(value) {
        return this.groupValue(value);
    }

    get EditComponent() {
        return EditComponent.bind(null, this.customField.id);
    }

    get ListComponent() {
        return ListComponent.bind(null, this.customField.id);
    }

    get ListGroupHeaderComponent() {
        return ListGroupHeaderComponent.bind(null, this.customField.id);
    }

    get TListGroupHeader1Component() {
        return TListGroupHeader1Component.bind(null, this.customField.id);
    }

    get TListGroupHeader2Component() {
        return TListGroupHeader2Component.bind(null, this.customField.id);
    }

    get ViewComponent() {
        return ViewComponent.bind(null, this.customField.id);
    }

    get FormAddComponent() {
        return FormComponent;
    }

    get FormNewComponent() {
        return FormNewComponent.bind(null, this.customField.id);
    }

    // // GLIST
    //
    // get GListValue() {
    //     // return ViewComponent.bind(null, this.customField.id);
    //     return RenderGListValue;  //.bind(null, this.customField.id);
    // }

    // IMPORT

    normalizeCSVValue(value) {

        const option = _.find(this.customField.params.listItems, li => {
            return li.value.toLowerCase().trim() === value.toLowerCase().trim()
        });

        if (option) return option.id;
        return null;
    }

    getComponentViewInImport() {
        return FieldDropdownViewInImport.bind(null, this); // this = custom field object
    }

}
